import { UIText1 } from '@cian/ui-kit/typography';
import { IconPlaceholderImage16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import styles from './NoImage.css';

type NoImageProps = {
  text?: string;
};

export const NoImage: FC<NoImageProps> = props => {
  const { text = 'Нет фото' } = props;

  return (
    <div className={styles['image']}>
      <div className={styles['image-icon']}>
        <IconPlaceholderImage16 color="icon-inverted-disabled" display="block" />
      </div>
      <UIText1 color="gray60_100" fontWeight="bold">
        {text}
      </UIText1>
    </div>
  );
};
